import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  DeleteOutlined,
  // EditOutlined,
  EyeOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { uuid } from "@ant-design/plots/es/utils";
import { Button, Dropdown, Form, Input, Space } from "antd";
import { DotVerticalIcon } from "assets/icons";
import _ from "lodash";
import { doGetWorkspacePage } from "stores/slices/workspace";

import SelectMultiple from "components/inputs/selectSearchSingle";

import AppButton from "../../components/button";
import ModalForm from "../../components/forms/components/modalForm";
import AppTable from "../../components/table";
import { PATTERNS, USER_TYPE } from "../../constants/appConstant";
import { AuthInfo } from "../../stores/slices/auth";
import {
  doCreateCustomField,
  doDeleteCustomField,
  doGetPageCustomField,
  doUpdateCustomField,
  numOfEls,
} from "../../stores/slices/customField";
import { setHeaderTitle, setIsRefresh } from "../../stores/slices/layout";

import styles from "../../components/styles.module.scss";
const CustomFields = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const authInfo = useSelector(AuthInfo);
  const noOfElements = useSelector(numOfEls);

  const dispatch = useDispatch();
  const [isView, setIsView] = useState(false);
  const [isOpenFrm, setIsOpenFrm] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [itemSelected, setItemSelected] = useState(null);
  const [selectedCustomField, setSelectedCustomField] = useState();
  const [isOpenModalDelete, setIsOpenModalDelete] = useState(false);

  const [searchParam, setSearchParam] = useState({
    searchKey: "",
    sortFieldCustomField: "createdTime",
    sortDirection: "DESC",
    pageNumber: 1,
    pageSize: 10,
    workspaceId: authInfo.workspaceId,
  });
  const [columns, setColumns] = useState([]);

  const [listAllWorkspace, setListAllWorkspace] = useState([]);
  const [totalWorkspacePages, setTotalWorkspacePages] = useState(0);
  const [workspaceQueries, setWorkspaceQueries] = useState({
    pageNumber: 1,
    pageSize: 10,
    statuses: ["ACTIVE"],
    sortFieldWorkspace: "createdTime",
  });
  const [workspaceOption, setOptionWorkspace] = useState([]);
  const [loadingList, setLoadingList] = useState(false);

  useEffect(() => {
    if (authInfo.type === USER_TYPE.SUPER_ADMIN) {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
    console.log("listAllWorkspace", listAllWorkspace);
  }, []);

  const fetchListWorkspace = async request => {
    const newRequest = {
      ...request,
      pageNumber: request.pageNumber,
      pageSize: request.pageSize,
      statuses: ["ACTIVE"],
      sortFieldWorkspace: "createdTime",
    };
    if (
      totalWorkspacePages > 0 &&
      totalWorkspacePages < newRequest.pageNumber
    ) {
      return;
    }
    if (request.isReset) {
      setOptionWorkspace([]);
      setListAllWorkspace([]);
      delete newRequest.isReset;
    }
    setLoadingList(true);
    const { payload } = await dispatch(doGetWorkspacePage(newRequest));
    if (payload && typeof payload !== "string") {
      if (request.isReset) {
        setListAllWorkspace(removeDuplicates([...payload.content]));
      } else {
        setListAllWorkspace(
          removeDuplicates([...listAllWorkspace, ...payload.content])
        );
      }
      setTotalWorkspacePages(payload.totalPages);
      setWorkspaceQueries(newRequest);
    }
    setLoadingList(false);
  };

  const removeDuplicates = arr => {
    console.log("arr", arr);
    return arr.filter(
      (ele, ind) => ind === arr.findIndex(elem => elem.id === ele.id)
    );
  };

  useEffect(() => {
    if (listAllWorkspace && listAllWorkspace?.length > 0) {
      const newOptions = listAllWorkspace.map(item => {
        return {
          key: item.id,
          label: item.name,
        };
      });
      setOptionWorkspace(newOptions);
    }
    // else {
    //   console.log("vo day");
    //   setOptionWorkspace([]);
    // }
  }, [listAllWorkspace]);

  const handleSearch = (selectedKeys, confirm) => {
    console.log("selectedKeys", selectedKeys);
    setSearchParam({ ...searchParam, pageNumber: 1 });
    confirm();
  };

  const handleTableChange = (pagination, filters, sorter) => {
    console.log("pagination", pagination);
    console.log("filters", filters);
    let newSearchParam = {
      workspaceId: authInfo.workspaceId,
    };
    filters.name &&
      (newSearchParam = {
        ...newSearchParam,
        searchKey: filters.name[0],
      });
    filters.workspaceName &&
      (newSearchParam = {
        ...newSearchParam,
        searchKeyWorkspaceName: filters.workspaceName[0],
      });

    if (sorter && sorter.columnKey && sorter.order) {
      newSearchParam = {
        ...newSearchParam,
        sortFieldCustomField: sorter.columnKey,
        sortDirection: sorter.order === "ascend" ? "ASC" : "DESC",
      };
    } else {
      newSearchParam = {
        ...newSearchParam,
        sortFieldCustomField: "createdTime",
        sortDirection: "DESC",
      };
    }

    newSearchParam = {
      ...newSearchParam,
      pageNumber: pagination.current,
      pageSize: pagination.pageSize,
    };
    console.log("newSearchParam", newSearchParam);
    setSearchParam(newSearchParam);
  };

  const actionOptionItems = record => {
    return [
      {
        key: "1",
        label: <span>{t("customField.viewAndEdit")}</span>,
        icon: <EyeOutlined />,
        onClick: () => {
          setIsView(true);
          setItemSelected(record);
          setIsOpenFrm(true);
        },
      },

      {
        key: "2",
        danger: true,
        label: <span>{t("customField.delete")}</span>,
        icon: <DeleteOutlined />,
        disabled: record?.type === USER_TYPE.SUPER_ADMIN,
        onClick: () => {
          setIsOpenModalDelete(true);
          setSelectedCustomField(record);
        },
      },
    ];
  };

  const generateTableColumns = () => {
    let cols = [
      {
        title: t("customField.fieldName"),
        dataIndex: "name",
        key: "name",
        sorter: true,
        isSearchable: true,
        ellipsis: {
          showTitle: false,
        },
      },
      {
        title: t("customField.actions"),
        width: 90,
        key: "operation",
        render: (_, record) => {
          return (
            <Space size="small">
              <Dropdown
                trigger={["click"]}
                menu={{
                  items: actionOptionItems(record),
                }}
                placement="bottomRight"
              >
                <Button type="text" shape="circle" size="middle">
                  <DotVerticalIcon />
                </Button>
              </Dropdown>
            </Space>
          );
        },
      },
    ];
    if (authInfo.type === USER_TYPE.SUPER_ADMIN) {
      cols = [
        {
          title: t("label.workspace"),
          // width: 80,
          dataIndex: "workspaceName",
          key: "workspaceName",
          sorter: true,
          // sortDirections: ["ascend", "descend"],
          isSearchable: true,
          searchPlaceholder:
            "Search by " + t("label.workspace").toString().toLowerCase(),
          ellipsis: {
            showTitle: false,
          },
          render: (_, { workspace }) => <>{workspace.name}</>,
        },
        {
          title: t("customField.fieldName"),
          dataIndex: "name",
          key: "name",
          sorter: true,
          isSearchable: true,
          ellipsis: {
            showTitle: false,
          },
        },

        {
          title: t("customField.actions"),
          width: 180,
          key: "operation",
          render: (_, record) => {
            return (
              <Space size="small">
                <Dropdown
                  trigger={["click"]}
                  menu={{
                    items: actionOptionItems(record),
                  }}
                  placement="bottomRight"
                >
                  <Button type="text" shape="circle" size="middle">
                    <DotVerticalIcon />
                  </Button>
                </Dropdown>
              </Space>
            );
          },
        },
      ];
    }
    setColumns(cols);
  };

  const handleDelete = async record => {
    const { payload } = await dispatch(doDeleteCustomField(record.id));
    setIsOpenModalDelete(false);
    if (payload && payload.status === 200) {
      if (searchParam.pageNumber > 1 && noOfElements === 1) {
        const newSearchParam = {
          ...searchParam,
          pageNumber: searchParam.pageNumber - 1,
        };
        setSearchParam(newSearchParam);
      }
      dispatch(setIsRefresh(uuid()));
      setIsDeleting(false);
    } else {
      setIsDeleting(false);
    }
  };

  useEffect(() => {
    if (itemSelected && itemSelected.workspace) {
      console.log("itemSelected", itemSelected);
      setOptionWorkspace([
        {
          key: itemSelected.workspace.id,
          label: itemSelected.workspace.name,
        },
      ]);
    }
  }, [itemSelected]);

  useEffect(() => {
    dispatch(setHeaderTitle(["customer", "customFields"]));
  }, []);

  useEffect(() => {
    generateTableColumns();
  }, [noOfElements]);

  useEffect(() => {
    if (authInfo && authInfo.workspaceId) {
      setSearchParam({ ...searchParam, workspaceId: authInfo.workspaceId });
      dispatch(setIsRefresh(uuid()));
    }
  }, [authInfo]);

  const handleTitleDelete = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <QuestionCircleOutlined style={{ color: "red", fontSize: 24 }} />
        <span style={{ marginLeft: 10, fontSize: 16 }}>
          {t("customField.deleteTitle")}
        </span>
      </div>
    );
  };

  return (
    <>
      {authInfo.type === USER_TYPE.USER && !authInfo.workspaceId ? (
        <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
          <div
            style={{
              fontSize: 20,
              fontWeight: "bold",
              textAlign: "center",
              marginTop: 50,
            }}
          >
            {t("customField.customFieldEmptyMsg")}
          </div>
          <AppButton
            label={t("user.goToWorkspaceManagement")}
            color={"primary"}
            type="primary"
            onClick={() => {
              navigate("/admin/workspaces");
            }}
            style={{
              marginLeft: "auto",
              marginRight: "auto",
            }}
          />
        </div>
      ) : (
        <div style={customFieldStyles.mainContainer}>
          <div
          // style={{ width: "70%", maxWidth: 800 }}
          >
            <div style={customFieldStyles.buttonContainer}>
              <AppButton
                label={t("button.add")}
                color={"primary"}
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setIsView(false);
                  setItemSelected(null);
                  setIsOpenFrm(true);
                }}
                style={customFieldStyles.buttonAdd}
              />
            </div>
            <AppTable
              api={doGetPageCustomField(searchParam)}
              columns={columns}
              searchParam={searchParam}
              handleSearch={handleSearch}
              handleTableChange={handleTableChange}
              setSearchParam={setSearchParam}
              scroll="auto"
            />
            <ModalForm
              title={
                itemSelected
                  ? isView
                    ? t("customField.viewPopupTitle")
                    : t("customField.updatePopupTitle")
                  : t("customField.addNewPopupTitle")
              }
              onCancel={() => setIsOpenFrm(false)}
              isOpen={isOpenFrm}
              footer={false}
              destroyOnClose={true}
              maskClosable={false}
            >
              <AddNewCustomFieldForm
                authInfo={authInfo}
                workspaceQueries={workspaceQueries}
                workspaceOption={workspaceOption}
                loadingList={loadingList}
                fetchListWorkspace={fetchListWorkspace}
                totalWorkspacePages={totalWorkspacePages}
                itemSelected={itemSelected}
                setIsOpenFrm={setIsOpenFrm}
                isView={isView}
                setIsView={setIsView}
              />
            </ModalForm>
            <ModalForm
              isOpen={isOpenModalDelete}
              type="confirm"
              title={handleTitleDelete()}
              onCancel={() => {
                setIsOpenModalDelete(false);
              }}
              okType={"danger"}
              danger={true}
              maskClosable={false}
              footer={[
                <AppButton
                  key="button"
                  label={t("button.cancel")}
                  color={"grey"}
                  loading={isDeleting}
                  disabled={isDeleting}
                  htmlType="button"
                  onClick={() => {
                    setIsOpenModalDelete(false);
                  }}
                />,
                <AppButton
                  key="button"
                  color="red"
                  label={t("button.delete")}
                  loading={isDeleting}
                  disabled={isDeleting}
                  onClick={() => {
                    setIsDeleting(true);
                    handleDelete(selectedCustomField);
                  }}
                />,
              ]}
            >
              <div style={{ height: 100, marginLeft: 35, fontSize: 14 }}>
                <div style={{ marginBottom: 12, fontWeight: "bold" }}>
                  {t("customField.deleteMsg")}
                </div>
                <div>{t("customField.deleteMsgConfirm")}</div>
              </div>
            </ModalForm>
          </div>
        </div>
      )}
    </>
  );
};
export const AddNewCustomFieldForm = props => {
  const {
    authInfo,
    workspaceQueries,
    workspaceOption,
    loadingList,
    fetchListWorkspace,
    totalWorkspacePages,
    itemSelected,
    setIsOpenFrm,
    isView,
    setIsView,
  } = props;
  const formRef = React.useRef(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleScrollWorkspace = event => {
    const clientHeight = event.target.clientHeight;
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    if (
      clientHeight + 10 - (scrollHeight - scrollTop) > 0 &&
      workspaceQueries.pageNumber <= totalWorkspacePages &&
      !loadingList
    ) {
      fetchListWorkspace({
        ...workspaceQueries,
        pageNumber: workspaceQueries.pageNumber + 1,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  };
  const onFinish = async fieldsValue => {
    const params = {
      workspaceId: authInfo.workspaceId || fieldsValue.workspace,
      name: fieldsValue["fieldName"],
    };
    setLoading(true);

    if (itemSelected) {
      params.id = itemSelected.id;
      const { payload } = await dispatch(doUpdateCustomField(params));
      if (payload && payload.status === 200) {
        setLoading(false);
        setIsOpenFrm(false);
        dispatch(setIsRefresh(uuid()));
      } else {
        setLoading(false);
      }
    } else {
      const { payload } = await dispatch(doCreateCustomField(params));
      if (payload && payload.status === 200) {
        setLoading(false);
        setIsOpenFrm(false);
        dispatch(setIsRefresh(uuid()));
      } else {
        setLoading(false);
      }
    }
  };
  const handleSearchKeyWorkspace = _.debounce(key => {
    if (key) {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        searchKeyName: key,
        isReset: true,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    } else {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        isReset: true,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  }, 300);
  const initValue = itemSelected => {
    if (itemSelected) {
      if (authInfo.type === USER_TYPE.SUPER_ADMIN) {
        return {
          fieldName: itemSelected.name,
          workspace: itemSelected.workspace.id,
        };
      } else {
        return {
          fieldName: itemSelected.name,
        };
      }
    }
  };
  console.log("workspaceOption", workspaceOption);
  return (
    <Form
      ref={formRef}
      layout={"vertical"}
      initialValues={initValue(itemSelected)}
      onFinish={onFinish}
    >
      {authInfo.type === USER_TYPE.SUPER_ADMIN && (
        <>
          <p className={styles.required} style={customFieldStyles.labelTitle}>
            {t("label.workspace")}
          </p>
          <Form.Item
            name="workspace"
            rules={[
              { required: true, message: t("validate.required") },
              {
                pattern: new RegExp(PATTERNS.XSS_PATTERN),
                message: t("validate.noxss"),
              },
            ]}
          >
            <SelectMultiple
              type={"select-search"}
              disabled={itemSelected ? true : false}
              loading={loadingList}
              showSearch
              allowClear={false}
              optionFilterProp="children"
              options={workspaceOption}
              onChange={value => {
                formRef.current.setFieldsValue({
                  workspace: value,
                });
              }}
              config={{
                width: "100%",
              }}
              handleSearch={handleSearchKeyWorkspace}
              handleScroll={handleScrollWorkspace}
            />
          </Form.Item>
        </>
      )}
      <p className={styles.required} style={customFieldStyles.labelTitle}>
        {t("customField.fieldName")}
      </p>
      <Form.Item
        name="fieldName"
        rules={[
          { required: true, message: t("validate.required") },
          {
            pattern: new RegExp(PATTERNS.XSS_PATTERN),
            message: t("validate.noxss"),
          },
        ]}
      >
        <Input disabled={isView} maxLength={255} />
      </Form.Item>
      <div style={customFieldStyles.buttonContainer}>
        <AppButton
          label={t("button.cancel")}
          color={"grey"}
          htmlType="button"
          onClick={() => {
            setIsOpenFrm(false);
          }}
        />
        {isView && (
          <AppButton
            label={t("button.edit")}
            color={"blue"}
            loading={loading}
            type="primary"
            htmlType="button"
            onClick={() => {
              setIsView(false);
            }}
          />
        )}
        {!isView && (
          <AppButton
            label={itemSelected ? t("button.save") : t("button.add")}
            color={"blue"}
            type="primary"
            disabled={loading}
            htmlType="submit"
          />
        )}
      </div>
    </Form>
  );
};
const customFieldStyles = {
  labelTitle: {
    marginBottom: "6px",
  },
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    // gap: "24px",
    marginBottom: "24px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 16,
    marginBottom: 24,
  },
  buttonAdd: {
    minWidth: "auto",
    marginLeft: 10,
  },
};

export default CustomFields;
